type ContentfulRichTextNode = {
  nodeType?: string;
  value?: string;
  content?: ContentfulRichTextNode[];
};

const getPlainTextFromRichText = (node?: ContentfulRichTextNode | null): string => {
  if (!node) return '';

  if (node.nodeType === 'text') {
    return node.value ?? '';
  }

  return node.content?.map(getPlainTextFromRichText).join('').replace(/\s+/g, ' ').trim() ?? '';
};

export default getPlainTextFromRichText;
